module.exports = __webpack_public_path__ + "img/cape-town-spurs-logo-icon.f8902597.png";